import { Colors, Services, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'

import { icons } from '@/utils'

export const presetOrDomain = {
  computed: {
    $_domainId() {
      return this.value?.meta?.domainId
    },
    $_presetId() {
      return this.value?.meta?.presetId
    },

    presetOrDomainStickerProps() {
      const value = this.$_presetId || this.$_domainId
      const result = {
        value,
        color: Colors.grey,
        copy: true
      }

      const setTo = service => {
        result.to = {
          name: getServiceNameViaPoint(service),
          params: { id: value }
        }
      }

      switch (true) {
        case Boolean(this.$_presetId): {
          const service = Services['url-shortener-settings/presets']
          result.label = this.getTranslate(`${Services['url-shortener']}.labels.presetId`)
          result.service = service
          result.icon = icons.list
          setTo(service)
          break
        }
        case Boolean(this.$_domainId): {
          const service = Services['url-shortener-settings/domains']
          result.label = this.getTranslate(`${Services['url-shortener']}.labels.domainId`)
          if (this.checkPermissions(`advanced.${getServiceNameViaPoint(service)}.get`)) {
            result.service = service
            result.pathToTitle = 'name'
            setTo(service)
          } else {
            result.value = this.value?.domain
          }
          result.icon = icons.domain
          break
        }
      }

      return result
    }
  }
}
